import { render, staticRenderFns } from "./CardWorkerConflict.vue?vue&type=template&id=2c5ad2b0"
import script from "./CardWorkerConflict.vue?vue&type=script&lang=js"
export * from "./CardWorkerConflict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports